import { useMemo } from "react";
import { ColumnFilter } from "./ColumnFilter";
import DropdownColumnFilter from "./DropDownColumnFilter";

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const date = new Date(dateString);
  return isNaN(date.getTime())
    ? "-"
    : date.toLocaleDateString("sl-SI", options);
};

export const COLUMNS = [
  {
    Header: "Status",
    accessor: "re_status",
    disableFilters: true,
  },
  {
    Header: "Podjetje/Poslovalnica",
    accessor: "pr_name",
    disableFilters: true,
  },
  {
    Header: "Komentar",
    id: "re_text",
    accessor: (d) => (d.re_text ? d.re_text : "/"),
  },
  {
    Header: "Jezik",
    accessor: "re_language",
    sortType: "basic",
    width: 60,
    Filter: DropdownColumnFilter, // Use the dropdown filter here
  },
  {
    Header: () => (
      <div
        style={{
          textAlign: "right",
        }}
      >
        Ocena
      </div>
    ),
    accessor: "re_score",
    sortType: "basic",
    width: 50,
    Filter: DropdownColumnFilter, // Use the dropdown filter here
    Cell: (row) => <div style={{ textAlign: "center" }}>{row.value}</div>,
  },
  {
    Header: "Test",
    id: "re_test",
    accessor: (d) => (d.re_test ? "DA" : "NE"),
    disableFilters: true,
  },
  {
    Header: "Št. slik",
    accessor: "re_img_url",
    sortType: "basic",
    disableFilters: true,
    Cell: (row) => <div style={{ textAlign: "center" }}>{row.value}</div>,
  },
  {
    Header: "Uporabnik",
    id: "user_name",
    accessor: (d) => (d.user_name ? d.user_name : "Anonimnež"),
    disableFilters: true,
  },
  {
    Header: "Produkt",
    accessor: "product_name",
    accessor: (d) => (d.product_name ? d.product_name : "/"),
    disableFilters: true,
  },
  { Header: "Ip Naslov", accessor: "re_ipaddress", disableFilters: true },
  {
    Header: "Št. podvprašanj",
    accessor: "answer_count",
    sortType: "basic",
    disableFilters: true,
    Cell: (row) => <div style={{ textAlign: "center" }}>{row.value}</div>,
  },
  {
    Header: "Objavljen",
    accessor: "re_created",
    disableFilters: true,
    Cell: ({ value }) => {
      return formatDate(value); // Format date as needed
    },
    sortType: (rowA, rowB, columnId, desc) => {
      const dateA = new Date(rowA.values[columnId]);
      const dateB = new Date(rowB.values[columnId]);
      return dateA - dateB;
    },
  },
];
